import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { PUBLIC_URL } from '../app.config'

export default memo(function AuthLogoAndImage({ children }) {
    return (
        <>
            <div className="row g-0">
                <div className="col-lg-6 d-none d-lg-block p-2">
                    <img src={PUBLIC_URL + "/assets/images/Appicon.png"} alt="" className="img-fluid rounded h-100" />
                    {/* <img src={PUBLIC_URL + "/assets/images/auth-img.png"} alt="" style={{background: "#d9f7eb"}} className="img-fluid rounded h-100" /> */}
                </div>
                <div className="col-lg-6">
                    <div className="d-flex flex-column h-100">
                        <div className="auth-brand p-4">
                            <Link to="/login" className="logo-dark">
                                <img src={PUBLIC_URL + "/assets/images/logo.png"} alt="dark logo" height="42" />
                            </Link>
                            <Link to="/login" className="logo-light">
                                <img src={PUBLIC_URL + "/assets/images/logo.png"} alt="logo" height="42" />
                            </Link>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </>
    )
})
